import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { Result } from '../interfaces/Result'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C603LogoUpdateProps {
  execLogoUpdate: (
    oldLogoName: string,
    newLogoName: string,
    file?: File,
    signed_url?: string,
  ) => Promise<Result>
  loading: loadStatus
}
// C603 ロゴ更新API呼出
export const useC603LogoUpdate = (): C603LogoUpdateProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execLogoUpdate = async (oldLogoName: string, newLogoName: string, file?: File, signed_url?: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // ボディ作成
      let body = {}
      if (file) {
        body = {
          old_logo_name: oldLogoName,
          logo_name: newLogoName,
          language: 'ja',
          file_name: file.name,
          url: signed_url,
        }
      } else {
        body = {
          old_logo_name: oldLogoName,
          logo_name: newLogoName,
          language: 'ja',
        }
      }

      const response = await axios.put(
        buildDeviceUrl(auth.deviceId, apiUrl.logosPath),
        body,
        {
          headers: header,
          validateStatus: () => true,
        }
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execLogoUpdate, loading }
}